import { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { roadmapsApi } from './shared/api';
import { Roadmap } from './shared/types';
import { LoadingState, EmptyState } from '@/components/ds';
import { Button } from '@/components/ui/button';
import { Map, Plus } from 'lucide-react';

interface RoadmapToolkitOutletContext {
    onCreateClick: () => void;
}

export function RoadmapRedirect() {
    const navigate = useNavigate();
    const { onCreateClick } = useOutletContext<RoadmapToolkitOutletContext>();
    const [isLoading, setIsLoading] = useState(true);
    const [isEmpty, setIsEmpty] = useState(false);

    useEffect(() => {
        const load = async () => {
            const { data } = await roadmapsApi.list();
            const roadmaps = (data as Roadmap[] | null) ?? [];
            if (roadmaps.length > 0) {
                navigate(`/roadmaps/${roadmaps[0].id}/goal-oriented`, { replace: true });
            } else {
                setIsEmpty(true);
                setIsLoading(false);
            }
        };
        load();
    }, [navigate]);

    if (isLoading && !isEmpty) {
        return <LoadingState fullPage />;
    }

    return (
        <div className="flex items-center justify-center h-full">
            <EmptyState
                icon={<Map className="w-16 h-16" />}
                title="No Roadmaps Yet"
                description="Create your first roadmap to get started"
                action={
                    <Button variant="brutal" onClick={onCreateClick}>
                        <Plus size={16} /> Create Roadmap
                    </Button>
                }
            />
        </div>
    );
}
